var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home page"},[_c('filters'),_c('main',[_c('selector',{attrs:{"landscapemode":_vm.landscapemode,"imagetype":_vm.imageRatio,"mapwidth":_vm.mapWidth,"mapheight":_vm.mapHeight}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }